<template>
    <div class="main-tab">
        <div class="main-tab__body">
            <keep-alive>
                <router-view :key="tabStackKey" />
            </keep-alive>
        </div>

        <van-tabbar
            v-if="showTabBar"
            route
            placeholder
            safe-area-inset-bottom
            active-color="#2B7DE9"
            inactive-color="#9AA8BC"
        >
            <van-tabbar-item replace to="/home">
                <span>会议室</span>
                <template #icon="props">
                    <svg class="tab-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M4 20V9.5L12 4l8 5.5V20H4z"
                            :stroke="props.active ? '#2B7DE9' : '#9AA8BC'"
                            stroke-width="1.7"
                            stroke-linejoin="round"
                        />
                        <path
                            d="M9.5 20v-6h5v6"
                            :stroke="props.active ? '#2B7DE9' : '#9AA8BC'"
                            stroke-width="1.7"
                            stroke-linejoin="round"
                        />
                    </svg>
                </template>
            </van-tabbar-item>

            <van-tabbar-item replace :to="isLoggedIn ? '/myBooking' : undefined" @click="onMyBookingClick">
                <span>我的预约</span>
                <template #icon="props">
                    <svg class="tab-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect
                            x="3.5" y="5" width="17" height="15" rx="2"
                            :stroke="props.active ? '#2B7DE9' : '#9AA8BC'"
                            stroke-width="1.7"
                        />
                        <path
                            d="M3.5 9.5h17M8 3.5v3M16 3.5v3"
                            :stroke="props.active ? '#2B7DE9' : '#9AA8BC'"
                            stroke-width="1.7"
                            stroke-linecap="round"
                        />
                        <circle
                            cx="12" cy="14.5" r="1.2"
                            :fill="props.active ? '#2B7DE9' : '#9AA8BC'"
                        />
                    </svg>
                </template>
            </van-tabbar-item>

            <van-tabbar-item v-if="isAdmin" replace to="/myReviews" :badge="reviewBadge">
                <span>我的审核</span>
                <template #icon="props">
                    <svg class="tab-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect
                            x="5" y="3.5" width="14" height="17" rx="2"
                            :stroke="props.active ? '#2B7DE9' : '#9AA8BC'"
                            stroke-width="1.7"
                        />
                        <path
                            d="M9 8.5h6M9 12h6"
                            :stroke="props.active ? '#2B7DE9' : '#9AA8BC'"
                            stroke-width="1.7"
                            stroke-linecap="round"
                        />
                        <path
                            d="M9 16.2l1.6 1.5L15 13.5"
                            :stroke="props.active ? '#2B7DE9' : '#9AA8BC'"
                            stroke-width="1.7"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                </template>
            </van-tabbar-item>

            <van-tabbar-item v-if="isAdmin" replace to="/meetingRoomManage">
                <span>会议室管理</span>
                <template #icon="props">
                    <svg class="tab-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect
                            x="3.5" y="4" width="17" height="16" rx="2"
                            :stroke="props.active ? '#2B7DE9' : '#9AA8BC'"
                            stroke-width="1.7"
                        />
                        <path
                            d="M3.5 10h17M8.5 4V7M15.5 4V7"
                            :stroke="props.active ? '#2B7DE9' : '#9AA8BC'"
                            stroke-width="1.7"
                            stroke-linecap="round"
                        />
                        <path
                            d="M8 14h3M8 17h8"
                            :stroke="props.active ? '#2B7DE9' : '#9AA8BC'"
                            stroke-width="1.7"
                            stroke-linecap="round"
                        />
                    </svg>
                </template>
            </van-tabbar-item>
        </van-tabbar>
    </div>
</template>

<script>
import { getStoredUserInfo } from '@/tools/utils';

export default {
    name: 'MainTab',
    data() {
        return {
            reviewBadge: '',
            userInfoVersion: 0,
        }
    },
    computed: {
        tabStackKey() {
            const stack = this.$route.matched[1]
            return stack ? stack.path : 'tab'
        },
        showTabBar() {
            return !this.$route.matched.some((r) => r.meta.hideTabBar)
        },
        isLoggedIn() {
            void this.userInfoVersion;
            return !!getStoredUserInfo();
        },
        isAdmin() {
            void this.userInfoVersion;
            const info = getStoredUserInfo();
            return !!(info && info.isAdmin);
        },
    },
    mounted() {
        this.syncReviewBadge();
        window.addEventListener('storage', this.syncReviewBadge);
        window.addEventListener('pending-review-count', this.onPendingCount);
        window.addEventListener('user-info-updated', this.refreshUserInfo);
    },
    activated() {
        this.refreshUserInfo();
    },
    beforeDestroy() {
        window.removeEventListener('storage', this.syncReviewBadge);
        window.removeEventListener('pending-review-count', this.onPendingCount);
        window.removeEventListener('user-info-updated', this.refreshUserInfo);
    },
    methods: {
        refreshUserInfo() {
            this.userInfoVersion += 1;
        },
        onMyBookingClick() {
            if (!this.isLoggedIn) {
                this.$router.push('/login')
            }
        },
        onPendingCount(e) {
            const count = Number(e.detail || 0)
            this.reviewBadge = count > 0 ? String(count) : ''
        },
        syncReviewBadge() {
            const count = Number(localStorage.getItem('pendingReviewCount') || 0)
            this.reviewBadge = count > 0 ? String(count) : ''
        },
    },
}
</script>

<style scoped>
.main-tab {
    min-height: 100vh;
    background: #eef3f9;
}

.main-tab__body {
    box-sizing: border-box;
}

.tab-icon {
    width: 0.44rem;
    height: 0.44rem;
    display: block;
}

.main-tab ::v-deep .van-tabbar {
    height: 1rem;
    z-index: 100;
    box-shadow: 0 -0.04rem 0.2rem rgba(30, 58, 95, 0.06);
}

.main-tab ::v-deep .van-tabbar-item {
    height: 1rem;
    font-size: 0.2rem;
}

.main-tab ::v-deep .van-tabbar-item__icon {
    margin-bottom: 0.06rem;
}
</style>
